import { SVGProps } from 'react'

const TelegramIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Artboard">
      <path
        id="Oval"
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="url(#paint0_linear_13037_231)"
      />
      <g transform="translate(-1, 0)">
        <path
          id="Path-3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.25326 7.49958C6.58542 6.48349 8.14056 5.81362 8.91868 5.48998C11.1404 4.5659 11.602 4.40538 11.9029 4.40008C11.9691 4.39892 12.1171 4.41532 12.2129 4.49309C12.2938 4.55876 12.3161 4.64748 12.3268 4.70974C12.3374 4.77201 12.3507 4.91385 12.3401 5.02468C12.2197 6.28966 11.6988 9.35946 11.4338 10.7763C11.3216 11.3758 11.1008 11.5768 10.8871 11.5965C10.4225 11.6392 10.0697 11.2894 9.61974 10.9945C8.91564 10.5329 8.51786 10.2456 7.83441 9.79522C7.04456 9.27472 7.55658 8.98865 8.00672 8.52112C8.12452 8.39877 10.1714 6.53693 10.2111 6.36803C10.216 6.34691 10.2206 6.26817 10.1738 6.22659C10.1271 6.18501 10.058 6.19923 10.0082 6.21054C9.93759 6.22657 8.81277 6.97003 6.63376 8.44092C6.31448 8.66016 6.02529 8.76698 5.76619 8.76138C5.48055 8.75521 4.93109 8.59988 4.52262 8.4671C4.02162 8.30425 3.62344 8.21814 3.65811 7.94157C3.67617 7.79751 3.87455 7.65018 4.25326 7.49958Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_13037_231"
        x1="8"
        y1="0"
        x2="8"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2AABEE" />
        <stop offset="1" stopColor="#229ED9" />
      </linearGradient>
    </defs>
  </svg>
)

export default TelegramIcon
